import React from 'react';
import ModalFormUI from './../../../widgets/form/ModalFormUI';
import InputReadOnlyUI from './../../../widgets/form/InputReadOnlyUI';

const CustomerDeleteModalUI = ({
    context, messageList, successMsg, errorList, customerName,
    // modes
    deleteMode, submitted,
    // event handlers
    onConfirmDeleteClick, onCancelClick, setErrorList,
  }) =>
    <ModalFormUI
        context={context}
        messageList={messageList}
        titleMessageKey='c_delete_customer'
        buttonMessageKey='c_remove'
        cancelMessageKey='c_cancel'
        isOpen={deleteMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onConfirmDeleteClick}
        busy={submitted}
    >
      <InputReadOnlyUI
        messageList={messageList}
        labelKey='c_customer_name'
        value={customerName}
        required={true}
      />

    </ModalFormUI>

export default CustomerDeleteModalUI
